module.exports = __webpack_public_path__ + "static/media/wheelchair.7017e826.svg";